import {
  CHANGE_MEMBERSHIP,
  CHANGE_STATUS,
  DELETE_USER,
  SET_USER,
  ADD_USER,
  COURSE_UNENROLL,
  EDIT_USER,
} from "../constants";

const initialState = [];

export const userReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_USER: {
      state = [...payload];
      return state;
    }
    case ADD_USER: {
      let temp = [...state];
      let index = temp.findIndex((user) => user.email === payload.email);
      if (index > -1) {
        temp[index] = payload;
      } else {
        temp = [payload, ...temp];
      }
      return temp;
    }
    
 case EDIT_USER: {

  let temp = [...state];
  let index = temp.findIndex((user) => user._id === payload._id);
  if (index > -1) {
    temp[index] = payload;
  }
  return temp;
}
    case CHANGE_STATUS: {
      let temp = [...state];
      let index = temp.findIndex((user) => user._id === payload);
      if (index > -1) {
        temp[index].is_active = !temp[index].is_active;
      }
      return temp;
    }
    case CHANGE_MEMBERSHIP: {
      let temp = [...state];
      let index = temp.findIndex((user) => user._id === payload._id);
      if (index > -1) {
        temp[index] = payload;
      }
      return temp;
    }
    case COURSE_UNENROLL: {
      let temp = [...state];
      let index = temp.findIndex((user) => user._id === payload.user_id);
      if (index > -1) {
        temp[index].enroll_course = temp[index].enroll_course.filter(
          (_) => _._id !== payload.course_id
        );
        temp[index].enroll_count = temp[index].enroll_count - 1;
      }
      return temp;
    }
    case DELETE_USER: {
      let temp = [...state];
      let index = temp.findIndex((user) => user._id === payload);
      if (index > -1) {
        temp.splice(index, 1);
      }
      return temp;
    }
    default: {
      return state;
    }
  }
};
